import { IconProps } from "./types";

export const ErrorIcon: React.FC<IconProps> = ({ fillColor }) => {
  return (
    <svg
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 0.5C2.66667 0.5 0 3.16667 0 6.5C0 9.83333 2.66667 12.5 6 12.5C9.33333 12.5 12 9.83333 12 6.5C12 3.16667 9.33333 0.5 6 0.5ZM5.2 3.23333C5.2 2.76667 5.53333 2.43333 6 2.43333C6.46667 2.43333 6.8 2.76667 6.8 3.23333V6.9C6.8 7.36667 6.46667 7.7 6 7.7C5.53333 7.7 5.2 7.36667 5.2 6.9V3.23333ZM6 10.4333C5.4 10.4333 4.93333 9.96667 4.93333 9.36667C4.93333 8.76667 5.4 8.3 6 8.3C6.6 8.3 7.06667 8.76667 7.06667 9.36667C7.06667 9.96667 6.6 10.4333 6 10.4333Z"
        fill={fillColor ?? "#D91C0B"}
      />
    </svg>
  );
};
